// import os from 'os'

// TODO fix os. os getting stripped out for node build
export default function getNodeOS() {
  return 'na' // os.platform()
}
